interface IconBookingStatusPlusOptions {
    cssClasses? : string
}

export function IconBookingStatusPlus(props : IconBookingStatusPlusOptions) {
    return (
        <svg id="bf1f4ca2-6f0a-4dd0-9324-d7779bd3799a" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className={props?.cssClasses}>
            <defs>
                <clipPath id="ab05dec1-d620-4038-a86d-4cdf2a228368" transform="translate(0)">
                    <rect className="adfe3c4f-30c3-4320-8a63-5b114cd6f254" width="16" height="16"/>
                </clipPath>
            </defs>
            <g className="a30d2798-9af2-4670-8b37-f69b23c82f0b">
                <path className="fb8a85be-1ed0-4f47-96e1-32cf4016ee4f" d="M8,12a.67.67,0,0,1-.67-.67V4.67a.67.67,0,1,1,1.33,0v6.66A.67.67,0,0,1,8,12Z" transform="translate(0)"/>
                <path className="fb8a85be-1ed0-4f47-96e1-32cf4016ee4f" d="M11.33,8.67H4.66a.67.67,0,0,1,0-1.34h6.67a.67.67,0,0,1,0,1.34Z" transform="translate(0)"/>
                <path className="fb8a85be-1ed0-4f47-96e1-32cf4016ee4f" d="M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.33A6.67,6.67,0,1,0,14.66,8,6.67,6.67,0,0,0,8,1.33Z" transform="translate(0)"/>
            </g>
        </svg>
    );
}
